import styled from 'styled-components';

import { BodySmallRegular } from '@xemplo/style-constants';

import { RadioButtonSize } from '../v1/radio-button.types';

import { RadioGroupV2Props } from './radio-button-v2.types';
import { RadioButtonRhf } from './radio-button-v2-rhf';

const StyledLabel = styled.label`
  cursor: pointer;
  &[data-disabled='true'] {
    pointer-events: none;
  }
  display: flex;
  align-items: center;
  gap: 12px;
  ${BodySmallRegular};
`;

export function RadioGroupV2({
  onChange,
  name,
  options,
  ariaLabel,
  size,
  showLabel,
  rules,
}: Readonly<RadioGroupV2Props>) {
  return options.map(({ id, label, value, disabled, error }, i) => (
    <StyledLabel key={`${name}-${value}-${options.length}`} data-disabled={disabled}>
      <RadioButtonRhf
        id={id}
        size={size ?? RadioButtonSize.Medium}
        onChange={(e) => !disabled && onChange?.(e)}
        name={name}
        value={value}
        disabled={disabled}
        ariaLabel={`${ariaLabel} ${label}`}
        rules={rules}
        error={error}
      />
      {showLabel && label}
    </StyledLabel>
  ));
}
export default RadioGroupV2;
